module.exports = "/_next/static/images/f32d1747e498acbc22aa91840d98b68e-hero-mobile.jpg";